/* eslint-disable no-unused-vars */
var resourcesList = ["cache-1ypn8kr.js","code-theme-css-ef37e5d9.js"];
module.exports.list = resourcesList
  